import { Link, graphql, useStaticQuery } from "gatsby";
import React, { useRef } from "react";
import logo from "../assets/images/logo.png";
import "../styles/header.css";
import BugerMenu from "./buger-menu";
import { StyledNavItems } from "./header.style";
import NavLink from "./nav-link";

const Header = () => {
    const menuEntries = useStaticQuery(graphql`
        query {
            site {
                siteMetadata {
                    menu {
                        name
                        link
                    }
                }
            }
        }
    `).site.siteMetadata.menu;

    const menuRef = useRef(null);
    const hiddenMenuRef = useRef(null);

    function showMenu() {
        menuRef.current.classList.toggle("clicked");
        hiddenMenuRef.current.classList.toggle("show");
    }

    return (
        <nav className="menu">
            <StyledNavItems>
                <Link to="/">
                    <img src={logo} alt="Mine Your Mind" width="300" height="22" />
                </Link>

                <ul className="menu-list">
                    {menuEntries.map((entry) => (
                        <li key={entry.link}>
                            <NavLink to={entry.link}>{entry.name}</NavLink>
                        </li>
                    ))}
                </ul>

                <BugerMenu onClick={showMenu} ref={menuRef} />
            </StyledNavItems>

            {/* eslint-disable-next-line jsx-a11y/click-events-have-key-events, jsx-a11y/no-static-element-interactions */}
            <div className="hidden-menu" ref={hiddenMenuRef} onClick={showMenu}>
                <ul className="hidden-menu-list">
                    {menuEntries.map((entry) => (
                        <li key={entry.link}>
                            <NavLink to={entry.link}>{entry.name}</NavLink>
                        </li>
                    ))}
                </ul>
            </div>
        </nav>
    );
};

export default Header;
